import { Directive, ElementRef, HostListener } from '@angular/core';
@Directive({
  selector: 'input[lettersOnly]'
})
export class LettersOnlyDirective {

  constructor(private _el: ElementRef) { }

  @HostListener('input', ['$event']) onInputChange(event) {
    const initalValue = this._el.nativeElement.value;
    this._el.nativeElement.value = initalValue.replace(/[^a-zA-ZÖöÇçŞşİiĞğÜü\s]/g, '');
    if ( this._el.nativeElement.value == 0 )
      event.stopPropagation();
    if ( initalValue !== this._el.nativeElement.value) {
      event.stopPropagation();
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/buyback-form/main-section/tabs/third-tab/letters-only.directive.ts